import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { CardElement, useElements, useStripe } from '@stripe/react-stripe-js';
import translate from '../../translate';
import StripeService from '../../../services/stripeService';
import {
  attachPaymentMethod,
  getStripeClientSecret,
} from '../../../services/checkoutHelper';
import { compose, PAYMENT_METHOD } from '../../../services/utilityFunctions';
import withCSRF from '../../withCSRF';
import BillingProp from '../../../sections/profile/propTypes/billingProp';
import Notifications from '../../../services/notifications';

function StripeCreditCardForm({
  t,
  _csrf,
  id,
  label,
  onFinish,
  onCancel,
  handleIsLoading,
  billing,
}) {
  const stripe = useStripe();
  const elements = useElements();
  const [error, setError] = useState(null);

  // useEffect(() => {
  //   const elements = StripeService.elements();
  //   const card = elements.create('card', { hidePostalCode: true });
  //   cardEl.current = card;
  //   card.addEventListener('change', ({ error: inputErr }) =>
  //     setError(StripeService.handleError(inputErr)),
  //   );
  //   card.mount(`#${id}`);
  //
  //   return () => cardEl.current.destroy();
  // }, []);

  const onSubmit = async event => {
    event.preventDefault();
    if (!stripe || !elements) {
      // Stripe.js hasn't yet loaded.
      // Make sure to disable form submission until Stripe.js has loaded.
      return;
    }
    handleIsLoading(true);
    try {
      const clientSecret = await getStripeClientSecret(
        _csrf,
        PAYMENT_METHOD.CREDIT_CARD,
      );
      const resultData = await stripe.confirmCardSetup(clientSecret, {
        payment_method: {
          card: elements.getElement(CardElement),
          billing_details: {
            name: billing?.billingAddress?.companyName ?? '',
            email: billing?.invoiceEmail ?? '',
          },
        },
      });
      if (resultData.error) {
        console.log(resultData.error.message);
        const errCode = StripeService.handleErrors(resultData.error);
        Notifications.showNotificationError(t('error'), t(errCode));
        setError(errCode);
      } else {
        const { setupIntent } = resultData;
        const paymentMethod = await attachPaymentMethod(
          _csrf,
          setupIntent.payment_method,
        );
        onFinish(paymentMethod);
      }
    } catch (err) {
      setError(err);
    }
    handleIsLoading(false);
  };

  return (
    <form onSubmit={onSubmit}>
      <div className="stripe-container">
        <label htmlFor={id}>{t(label)}</label>
        <div className="stripe-input-container">
          <div id={id} />
          <CardElement
            name="stripeCreditCard"
            options={{ hidePostalCode: true }}
          />
          {onCancel && (
            <button
              type="button"
              onClick={onCancel}
              className="stripe-button stripe-cancel-button"
            >
              {t('cancel')}
            </button>
          )}
          <button
            type="submit"
            // onClick={handleAdd}
            className="stripe-button stripe-finish-button"
          >
            {t('add_card')}
          </button>
        </div>
        <div className="stripe-error-container" role="alert">
          {error ? t(error) : ''}
        </div>
      </div>
    </form>
  );
}

StripeCreditCardForm.propTypes = {
  t: PropTypes.func.isRequired,
  _csrf: PropTypes.string.isRequired,
  id: PropTypes.string,
  label: PropTypes.string,
  onFinish: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  handleIsLoading: PropTypes.func.isRequired,
  billing: PropTypes.shape(BillingProp.propType),
};

StripeCreditCardForm.defaultProps = {
  id: 'stripe-input',
  label: 'stripe_inputLabel',
  billing: BillingProp.defaultProp,
};

export default compose(translate, withCSRF)(StripeCreditCardForm);
